import React from "react";
import { useIntl } from "react-intl";

import CheckboxItem from "../../app/generic/checkboxItem";
import ServiceWithParameter from "./serviceWithParameter";

const Manipulation = ({
  getFieldDecorator,
  initialServices,
  disabled,
  pickup,
  label,
}) => {
  const intl = useIntl();
  return (
    <ServiceWithParameter label={label}>
      <CheckboxItem
        labelCol={1}
        wrapperCol={20}
        disabled={disabled}
        checkboxLabel={intl.formatMessage({
          id: "consignment.services.palletJack",
          defaultMessage: "paletový vozík",
        })}
        className="service-form-manipulation"
        getFieldDecorator={getFieldDecorator}
        fieldName={`${pickup ? "pickup" : "delivery"}ManipulationCart`}
        initialValue={
          initialServices &&
          (pickup
            ? initialServices.pickupManipulationCart
            : initialServices.deliveryManipulationCart)
        }
      />
      <CheckboxItem
        labelCol={1}
        wrapperCol={20}
        disabled={disabled}
        checkboxLabel={intl.formatMessage({
          id: "consignment.services.tailLift",
          defaultMessage: "hydraulické čelo",
        })}
        className="service-form-manipulation"
        getFieldDecorator={getFieldDecorator}
        fieldName={`${pickup ? "pickup" : "delivery"}ManipulationFront`}
        initialValue={
          initialServices &&
          (pickup
            ? initialServices.pickupManipulationFront
            : initialServices.deliveryManipulationFront)
        }
      />
    </ServiceWithParameter>
  );
};

export default Manipulation;
